import React, { useCallback, useState, useEffect } from 'react'
import { Autocomplete } from '@workboard/wobo-ui'
import { createFilterOptions } from '@material-ui/lab/Autocomplete'
import timezones from './timezones.json'
import './timezone-input.scss'

export const DEFAULT_TIMEZONE = 'America/New_York'

export const deconstructTimezone = (timezone) => {
  const [region, city] = timezone.value.split('/')
  return { ...timezone, region, city }
}

const regionalizedTimezones = [...timezones.map(deconstructTimezone)]

const ListHeader = ({ group }) => (
  <li className="meeting-timezone__heading">
    {group}
  </li>
);

const TimezoneInput = ({
  timezoneValue = '',
  onSelect = () => null,
  placeholder,
  isDisabled = false,
  isGrouped = false,
  ...props
}) => {
  const { className } = props

  const getOptionByValue = (val) => {
    const matchVal = val || DEFAULT_TIMEZONE
    return regionalizedTimezones.find((tz) => tz?.value === matchVal)
  }

  const defaultValue = timezoneValue ? getOptionByValue(timezoneValue) : null

  const handleSelect = (e, option) => {
    if (option) {
      onSelect(option.value)
    }
  }

  const startWithFilter = createFilterOptions({
    stringify: (option) =>
      (option?.city || '') +
      (option?.label || '') +
      (option?.value || '') +
      (option?.tags || ''),
  })

  // Add check for timezoneValue !== null to prevent loading the component before we
  // potentially know the correct timezone to set the defaultValue (e.g. in 1on1 form)
  return (
    timezoneValue !== null && (
      <div {...(className ? { className } : {})}>
        <Autocomplete
          autoSelect={false}
          icon={null}
          startMatch={false}
          isDisabled={isDisabled}
          rootProps={{
            'data-testid': 'autocomplete-timezone',
            id: 'wb-timezone', // Temporarily styling against id until wobo-ui Autocomplete bug with class rootProp is fixed
          }}
          defaultValue={defaultValue}
          options={regionalizedTimezones}
          getOptionLabel={(option) => option?.label || ''}
          filterOptions={startWithFilter}
          {...(isGrouped
            ? {
                groupBy: ({ region }) => region,
              }
            : {})}
          headerTemplate={ListHeader}
          onChange={handleSelect}
          placeholder={placeholder}
          panelProps={{
            zIndex: 1300,
            disablePortal: true,
          }}
        />
      </div>
    )
  )
}

export default TimezoneInput
